// サイズパターン/展開コードの選択肢取得とサイズ明細への反映をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createPdtSizePatternService(deps) {
    const {
        AGRef,
        BRAND_HINBAN_COLUMNID,
        BRAND_HINBAN_SERIAL_SELECT_MODE,
        CELLTYPE,
        DETAIL_HEADER_PANEL,
        DicVal,
        GridApi,
        GridColApi,
        GridData,
        KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE,
        KAKOUSIJI_SOSEI_CALC_PANEL_TYPE,
        PDTC_SIZE_PATTERN_REQUIRED_MESSAGE,
        PDTC_SIZE_SELECTED_FIELD,
        PDT_ITEM_DETAIL_PANEL,
        PDT_SIZE_PATTERN_FIELD_IDS,
        SUB_BRAND_COLUMNID,
        SetGridData,
        assignEntryDataCurrent,
        columninfo,
        columns,
        createBrandHinbanSerialSearchField,
        dispatch,
        entrydata,
        entrydataRef,
        entryrerender,
        extractKakousijiMasterCode,
        firstNonEmptyValue,
        fnc,
        formstatus,
        getEntryDataValue,
        getHinbanSoseiPanelColumnInfo,
        gridlist,
        initialPdtcDetail220Ref,
        isEmpty,
        isPdtcSizeRowSelected,
        loadItemMasterInfo,
        loadQrcMinHachuTani,
        loadQrcPackIrisu,
        matchesColumnId,
        normalizeKakousijiText,
        normalizeSoseiColumnId,
        pdtSizePatternOptionsRef,
        pdtSizePatternOptionsRequestSeqRef,
        pdtTenkaiCodeChangedAfterLoadRef,
        pdtcDetailPanel,
        pdtcSizeCodesFromSkuRows,
        pdtcSizeOptionsRef,
        pdtcSizePatternRequestSeqRef,
        protectHbSeasonCommit,
        readKakousijiRowValueIgnoreCase,
        rerender,
        resolveBrandGroupBrandCode,
        resolveBrandHinbanPrefix,
        sectionHeaderData,
        setEntryDataValue,
        setEntryGridRows,
        setSubBrandFieldOptions,
        setcolumninfo,
        setcolumns,
        settextfields,
        settextfieldsall,
        textfields,
        textfieldsall,
        updateSectionHeaderSizePatternValue,
        updateSectionHeaderValue
    } = deps;

    function resolveItemMasterItemCode(data) {
        const directValue = firstNonEmptyValue(data, ["PDT_ITMCITEMCD", "PDT_ITMCITEMCD", "BITM_SubCode", "ITEMCD"]);
        if (!isEmpty(directValue)) return directValue;
        const syohinCode = firstNonEmptyValue(data, ["PDT_SYOHINCD", "SYOHINCD"]);
        if (syohinCode.length >= 7) return syohinCode.substring(5, 7);
        return "";
    }
    function applyFirstExistingValue(data, targets, value) {
        if (isEmpty(data) || isEmpty(targets)) return false;
        const text = String(isEmpty(value) ? "" : value);
        let updated = false;
        for (let i = 0; i < targets.length; i++) {
            if (!(targets[i] in data)) continue;
            data[targets[i]] = text;
            updated = true;
            break;
        }
        return updated;
    }
    function setPdtItmcItemCdOnEntryData(targetData, value) {
        if (isEmpty(targetData)) return false;
        const text = String(isEmpty(value) ? "" : value).trim();
        if (String(DicVal(targetData, "PDT_ITMCITEMCD", "")).trim() === text) return false;
        targetData.PDT_ITMCITEMCD = text;
        return true;
    }
    function clearPdtTenkaiCodeValue(targetData) {
        if (isEmpty(targetData)) return false;
        let changed = false;
        if (String(DicVal(targetData, "PDT_TENKAICODE", "")).trim() !== "") {
            targetData.PDT_TENKAICODE = "";
            changed = true;
        }
        const headerValue = String(DicVal(sectionHeaderData(DETAIL_HEADER_PANEL), "PDT_TENKAICODE", "")).trim();
        if (!isEmpty(headerValue)) {
            updateSectionHeaderValue(DETAIL_HEADER_PANEL, "PDT_TENKAICODE", "");
            changed = true;
        }
        return changed;
    }
    function applyPdtTenkaiCodeAutoSelection(targetData, value) {
        const code = String(value ?? "").trim();
        if (isEmpty(code)) return false;
        let changed = false;
        if (!isEmpty(targetData) && typeof targetData === "object" && String(DicVal(targetData, "PDT_TENKAICODE", "")).trim() !== code) {
            targetData.PDT_TENKAICODE = code;
            changed = true;
        }
        if (isEmpty(entrydataRef.current) || typeof entrydataRef.current !== "object") entrydataRef.current = {};
        if (String(DicVal(entrydataRef.current, "PDT_TENKAICODE", "")).trim() !== code) {
            entrydataRef.current.PDT_TENKAICODE = code;
            changed = true;
        }
        const headerValue = String(DicVal(sectionHeaderData(DETAIL_HEADER_PANEL), "PDT_TENKAICODE", "")).trim();
        if (headerValue !== code) {
            updateSectionHeaderValue(DETAIL_HEADER_PANEL, "PDT_TENKAICODE", code);
            changed = true;
        }
        if (changed) {
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
        }
        return changed;
    }
    function pdtTenkaiCodeOptionsFromReturnData(returnData) {
        const count = Number(DicVal(returnData, "Count", "0"));
        const options = [];
        const used = new Set();
        for (let i = 1; i <= count; i++) {
            const code = String(DicVal(returnData, `PDTL_TENKAICODE${i}`, "")).trim();
            if (isEmpty(code) || used.has(code)) continue;
            used.add(code);
            options.push({ code: code, name: code });
        }
        return options;
    }
    function loadPdtTenkaiCodeOptionsForData(targetData, options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(targetData) ? {} : targetData)
        };
        const brandCode = String(resolveBrandGroupBrandCode(source)).trim();
        const itemCode = String(firstNonEmptyValue(source, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        if (isEmpty(brandCode) || isEmpty(itemCode)) return;
        if (isEmpty(fnc.current)) return;
        fnc.current.postaxios("hinbanmaster/GetPdtTenkaiCodes",
            {
                PDT_BRDCODE: brandCode,
                PDT_ITMCITEMCD: itemCode
            },
            {
                onSuccess: function (data) {
                    const codeOptions = pdtTenkaiCodeOptionsFromReturnData(DicVal(data, "returnData", {}));
                    if (codeOptions.length === 0) return;
                    const firstCode = String(DicVal(codeOptions[0], "code", "")).trim();
                    applyPdtTenkaiCodeAutoSelection(targetData, firstCode);
                    loadPdtTenkaiSizePatternInfo(firstCode, {
                        silent: DicVal(requestOptions, "silent", true),
                        targetData: targetData
                    });
                }
            },
            true
        );
    }
    function refreshPdtItmcItemCdDependentOptions(targetData, options) {
        if (isEmpty(targetData)) return;
        const requestOptions = isEmpty(options) ? {} : options;
        if (clearPdtTenkaiCodeValue(targetData)) {
            assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
        }
        loadPdtSizePatternOptions({
            silent: DicVal(requestOptions, "silent", true),
            targetData: targetData,
            autoSelectFirst: true
        });
        applyPdtcSizeOptions([]);
        loadPdtTenkaiCodeOptionsForData(targetData, {
            silent: DicVal(requestOptions, "silent", true)
        });
    }
    function buildPdtTenkaiSearchField(field, currentData) {
        if (isEmpty(field) || field.columnid !== "PDT_TENKAICODE") return null;
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(currentData) ? {} : currentData)
        };
        const brandCode = String(resolveBrandGroupBrandCode(source)).trim();
        const itemCode = String(firstNonEmptyValue(source, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        if (isEmpty(brandCode) || isEmpty(itemCode)) {
            fnc.current.warnmsg("先にブランドとブランドサブアイテムを入力してください");
            return false;
        }
        return new Promise((resolve) => {
            if (isEmpty(fnc.current)) return;
        fnc.current.postaxios("hinbanmaster/GetPdtTenkaiCodes",
                {
                    PDT_BRDCODE: brandCode,
                    PDT_ITMCITEMCD: itemCode
                },
                {
                    onSuccess: function (data) {
                        const options = pdtTenkaiCodeOptionsFromReturnData(DicVal(data, "returnData", {}));
                        if (options.length === 0) {
                            fnc.current.warnmsg("該当するサイズ展開コードがありません");
                            resolve(false);
                            return;
                        }
                        resolve({
                            ...field,
                            dataid: "",
                            datatype: CELLTYPE.SELECT,
                            options: options,
                            keyinfo: ""
                        });
                    },
                    onError: function (response) {
                        const message = String(DicVal(response, "errDescription", "")).trim();
                        fnc.current.warnmsg(isEmpty(message) ? "サイズ展開コードの取得に失敗しました" : message);
                        resolve(false);
                    }
                },
                true
            );
        });
    }
    function normalizeSubBrandOptions(rows) {
        const sourceRows = Array.isArray(rows) ? rows : [];
        const options = [];
        const used = new Set();
        sourceRows.forEach((row) => {
            const code = String(DicVal(row, "SBR_CODE", "")).trim();
            const name = String(DicVal(row, "SBR_SUBNAME", DicVal(row, "SBR_NAME", ""))).trim();
            if (isEmpty(code) || used.has(code)) return;
            used.add(code);
            options.push({ code: code, name: isEmpty(name) ? code : name });
        });
        return options;
    }
    function currentSubBrandOptions() {
        const sources = [textfieldsall, textfields, columninfo, columns];
        for (let i = 0; i < sources.length; i++) {
            const field = (Array.isArray(sources[i]) ? sources[i] : []).find((item) => matchesColumnId(DicVal(item, "columnid", DicVal(item, "field", "")), SUB_BRAND_COLUMNID));
            const options = DicVal(field, "options", null);
            if (Array.isArray(options) && options.length !== 0) return options;
        }
        return [];
    }
    function applySubBrandNameToEntryData(targetData, options) {
        if (isEmpty(targetData)) return false;
        const code = String(getEntryDataValue(targetData, SUB_BRAND_COLUMNID, "")).trim();
        if (isEmpty(code)) return false;
        const optionList = Array.isArray(options) ? options : currentSubBrandOptions();
        const option = optionList.find((item) => String(DicVal(item, "code", "")).trim() === code);
        if (isEmpty(option)) return false;
        return setEntryDataValue(targetData, SUB_BRAND_COLUMNID + "_nm", String(DicVal(option, "name", code)).trim());
    }
    function loadSubBrandName(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null)) ? entrydataRef.current : DicVal(requestOptions, "targetData", null);
        if (isEmpty(targetData)) return;
        const brandCode = String(resolveBrandGroupBrandCode(targetData)).trim();
        const subBrandCode = String(getEntryDataValue(targetData, SUB_BRAND_COLUMNID, "")).trim();
        if (isEmpty(brandCode) || isEmpty(subBrandCode)) return;
        if (isEmpty(fnc.current)) return;
        fnc.current.postaxios("hinbanmaster/GetSubBrandList",
            { PDT_BRDCODE: brandCode },
            {
                onSuccess: function (data) {
                    const rows = Array.isArray(DicVal(DicVal(data, "data", {}), "rows", null)) ? DicVal(data.data, "rows", []) : [];
                    const options = normalizeSubBrandOptions(rows);
                    if (options.length !== 0) setSubBrandFieldOptions(options);
                    const changed = applySubBrandNameToEntryData(targetData, options);
                    if (!changed || targetData !== entrydataRef.current) return;
                    dispatch(entrydata({ ...entrydataRef.current }));
                    dispatch(entryrerender());
                }
            },
            true
        );
    }
    function buildSubBrandSearchField(field, currentData) {
        if (isEmpty(field) || field.columnid !== SUB_BRAND_COLUMNID) return null;
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(currentData) ? {} : currentData)
        };
        const brandCode = String(resolveBrandGroupBrandCode(source)).trim();
        if (isEmpty(brandCode)) {
            fnc.current.warnmsg("先にブランドを入力してください");
            return false;
        }
        return new Promise((resolve) => {
            if (isEmpty(fnc.current)) return;
        fnc.current.postaxios("hinbanmaster/GetSubBrandList",
                { PDT_BRDCODE: brandCode },
                {
                    onSuccess: function (data) {
                        const rows = Array.isArray(DicVal(DicVal(data, "data", {}), "rows", null)) ? DicVal(data.data, "rows", []) : [];
                        const options = normalizeSubBrandOptions(rows);
                        if (options.length === 0) {
                            fnc.current.warnmsg("該当するサブブランドがありません");
                            resolve(false);
                            return;
                        }
                        setSubBrandFieldOptions(options);
                        resolve({
                            ...field,
                            dataid: "",
                            datatype: CELLTYPE.SELECT,
                            options: options,
                            keyinfo: ""
                        });
                    },
                    onError: function (response) {
                        const message = String(DicVal(response, "errDescription", "")).trim();
                        fnc.current.warnmsg(isEmpty(message) ? "サブブランドの取得に失敗しました" : message);
                        resolve(false);
                    }
                },
                true
            );
        });
    }
    function buildBrandHinbanSearchField(field, currentData) {
        if (isEmpty(field) || !matchesColumnId(field.columnid, BRAND_HINBAN_COLUMNID)) return null;
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(currentData) ? {} : currentData)
        };
        if (isEmpty(resolveBrandHinbanPrefix(source))) {
            fnc.current.warnmsg("先にブランド、年度、シーズン、アイテムを入力してください");
            return false;
        }
        return createBrandHinbanSerialSearchField(field, BRAND_HINBAN_SERIAL_SELECT_MODE.SYOHINCD);
    }
    function isKakousijiSubSoseiSearchField(field) {
        const panelType = normalizeKakousijiText(DicVal(field, 'type', ''));
        if (![KAKOUSIJI_QUALITY_DISPLAY_PANEL_TYPE, KAKOUSIJI_SOSEI_CALC_PANEL_TYPE].includes(panelType)) return false;
        const columnId = normalizeSoseiColumnId(DicVal(field, 'columnid', DicVal(field, 'field', '')));
        const dataId = normalizeSoseiColumnId(DicVal(field, 'dataid', DicVal(field, 'mastertype', DicVal(field, 'dataidctrl', '')))).split(':')[0];
        return columnId === 'SSDQ_SUB_SOSEICD'
            || columnId === 'SSDQNR_SUBSOSEICD1'
            || dataId === 'M_SSOS';
    }
    function ensureSubSoseiSearchParentCode(field, currentData) {
        if (!isKakousijiSubSoseiSearchField(field) || isEmpty(currentData) || typeof currentData !== 'object') return;
        const panelType = normalizeKakousijiText(DicVal(field, 'type', ''));
        const meta = getHinbanSoseiPanelColumnInfo({ type: panelType });
        const candidates = [
            meta.mainCol,
            `${meta.mainCol}_cd`,
            'SSDQ_SOSEICD',
            'SSDQ_SOSEICD_cd',
            'SSDH_SOSEICD',
            'SSDH_SOSEICD_cd'
        ].filter((key) => normalizeKakousijiText(key) !== '');
        let parentCode = '';
        for (let i = 0; i < candidates.length; i++) {
            const rawValue = readKakousijiRowValueIgnoreCase(currentData, candidates[i]);
            parentCode = extractKakousijiMasterCode(rawValue) || normalizeKakousijiText(rawValue);
            if (parentCode !== '') break;
        }
        if (parentCode === '') return;
        currentData.SSDQ_SOSEICD = parentCode;
        currentData.SSDQ_SOSEICD_cd = parentCode;
    }
    function buildBaseSearchField(field, currentData) {
        ensureSubSoseiSearchParentCode(field, currentData);
        const brandHinbanSearch = buildBrandHinbanSearchField(field, currentData);
        if (brandHinbanSearch !== null) return brandHinbanSearch;
        const subBrandSearch = buildSubBrandSearchField(field, currentData);
        if (subBrandSearch !== null) return subBrandSearch;
        const pdtSizePatternSearch = buildPdtSizePatternSearchField(field, currentData);
        if (pdtSizePatternSearch !== null) return pdtSizePatternSearch;
        const pdtcSizeSearch = buildPdtcSizeSearchField(field, currentData);
        if (pdtcSizeSearch !== null) return pdtcSizeSearch;
        return buildPdtTenkaiSearchField(field, currentData);
    }
    function syncItemDependentData(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        loadQrcPackIrisu({ silent: DicVal(requestOptions, "silent", true), force: true });
        loadQrcMinHachuTani({ silent: DicVal(requestOptions, "silent", true), force: true });
        loadItemMasterInfo({ silent: DicVal(requestOptions, "silent", true) });
    }
    function pdtItemCodesPanel() {
        const panelRef = gridlist.find((item) =>
            String(DicVal(item, "id", "")) === PDT_ITEM_DETAIL_PANEL.id &&
            String(DicVal(item, "type", "")) === PDT_ITEM_DETAIL_PANEL.type
        );
        if (!isEmpty(panelRef)) return panelRef;
        return {
            id: PDT_ITEM_DETAIL_PANEL.id,
            type: PDT_ITEM_DETAIL_PANEL.type
        };
    }
    function pdtcSizeCodePanels() {
        if (isEmpty(gridlist)) return [];
        return gridlist.filter((item) => String(DicVal(item, "type", "")).trim() === "210");
    }
    function setDetailColumnValues(panelRef, columnid, values) {
        const normalizedValues = (isEmpty(values) ? [] : values)
            .map((value) => String(isEmpty(value) ? "" : value).trim())
            .filter((value) => !isEmpty(value));
        const requiredCount = normalizedValues.length;
        const gridApi = GridApi(panelRef);

        if (!isEmpty(gridApi)) {
            let rows = AGRef.current.GetDatasource(gridApi);
            if (isEmpty(rows)) rows = [];
            if (requiredCount > rows.length) {
                AGRef.current.newRow(requiredCount - rows.length, gridApi, GridColApi(panelRef));
                rows = AGRef.current.GetDatasource(gridApi);
            }

            for (let i = 0; i < rows.length; i++) {
                const row = rows[i];
                const nextValue = i < normalizedValues.length
                    ? normalizedValues[i]
                    : DicVal(row, columnid, "");
                const newRow = {
                    ...row,
                    [columnid]: nextValue
                };
                if (!isEmpty(row) && !isEmpty(row.rowid)) {
                    const rowNode = gridApi.getRowNode(row.rowid);
                    if (!isEmpty(rowNode)) rowNode.setData(newRow);
                }
            }

            SetGridData(panelRef, AGRef.current.GetDatasource(gridApi));
            return;
        }

        let rows = GridData(panelRef);
        if (isEmpty(rows)) rows = [];
        const targetCount = Math.max(requiredCount, rows.length);
        if (targetCount === 0 && rows.length === 0) {
            SetGridData(panelRef, []);
            return;
        }
        const newRows = [];
        for (let i = 0; i < targetCount; i++) {
            const sourceRow = i < rows.length && !isEmpty(rows[i]) ? rows[i] : {};
            newRows.push({
                ...sourceRow,
                [columnid]: i < normalizedValues.length
                    ? normalizedValues[i]
                    : DicVal(sourceRow, columnid, "")
            });
        }
        SetGridData(panelRef, newRows);
    }
    function setPdtItemCodesToDetailGrid(itemCodes) {
        const panelRef = pdtItemCodesPanel();
        setDetailColumnValues(panelRef, "PDT_ITMCITEMCD", itemCodes);
    }
    function normalizeDetailColumnValues(values) {
        if (!Array.isArray(values)) return [];
        return values.map((value) => String(isEmpty(value) ? "" : value).trim());
    }
    function displayInitialBlankDetailGridRow(panelRef) {
        const api = GridApi(panelRef);
        const columnApi = GridColApi(panelRef);
        if (isEmpty(api) || isEmpty(AGRef.current) || isEmpty(columnApi) || typeof AGRef.current.initialrowData !== "function") {
            SetGridData(panelRef, []);
            return;
        }
        const initialRows = AGRef.current.initialrowData(1, columnApi);
        const displayRows = Array.isArray(initialRows) ? initialRows : [];
        SetGridData(panelRef, displayRows);
        if (typeof api.setGridOption === "function") {
            api.setGridOption("rowData", displayRows);
        } else if (typeof api.setRowData === "function") {
            api.setRowData(displayRows);
        }
        if (typeof api.refreshCells === "function") {
            api.refreshCells({ force: true });
        }
    }
    function overwriteDetailColumnValues(panelRef, columnValues) {
        const normalizedColumnValues = {};
        Object.keys(columnValues || {}).forEach((columnid) => {
            normalizedColumnValues[columnid] = normalizeDetailColumnValues(columnValues[columnid]);
        });
        const rowCount = Object.values(normalizedColumnValues).reduce((maxCount, values) => Math.max(maxCount, values.length), 0);
        if (rowCount === 0) {
            displayInitialBlankDetailGridRow(panelRef);
            return;
        }
        let seedRows = [];
        const columnApi = GridColApi(panelRef);
        if (!isEmpty(AGRef.current) && !isEmpty(columnApi) && typeof AGRef.current.initialrowData === "function") {
            const initialRows = AGRef.current.initialrowData(rowCount, columnApi);
            if (Array.isArray(initialRows)) seedRows = initialRows;
        }
        const nextRows = [];
        for (let i = 0; i < rowCount; i++) {
            const nextRow = i < seedRows.length && !isEmpty(seedRows[i]) ? { ...seedRows[i] } : {};
            Object.keys(normalizedColumnValues).forEach((columnid) => {
                nextRow[columnid] = i < normalizedColumnValues[columnid].length
                    ? normalizedColumnValues[columnid][i]
                    : "";
            });
            nextRows.push(nextRow);
        }
        setEntryGridRows(panelRef, nextRows);
    }
    function setPdtcSizeCodesToDetailGrid(sizeCodes, posSizeCodes = [], options = {}) {
        pdtcSizeCodePanels().forEach((panelRef) => {
            if (DicVal(options, "overwrite", false)) {
                const selectedSizeCodes = pdtcSizeCodesFromSkuRows(initialPdtcDetail220Ref.current);
                overwriteDetailColumnValues(panelRef, {
                    PDTC_SIZECD: sizeCodes,
                    PDTC_BCODESIZE: posSizeCodes,
                    [PDTC_SIZE_SELECTED_FIELD]: (Array.isArray(sizeCodes) ? sizeCodes : []).map((sizeCode) =>
                        selectedSizeCodes.has(String(isEmpty(sizeCode) ? "" : sizeCode).trim()) ? "1" : "0")
                });
                return;
            }
            setDetailColumnValues(panelRef, "PDTC_SIZECD", sizeCodes);
            setDetailColumnValues(panelRef, "PDTC_BCODESIZE", posSizeCodes);
        });
    }
    function normalizePdtcSizeOptions(sizeInfoList) {
        const normalized = [];
        const used = new Set();
        (Array.isArray(sizeInfoList) ? sizeInfoList : []).forEach((row) => {
            const code = String(DicVal(row, "SZP_SIZECD", DicVal(row, "SZPC_SIZECD", ""))).trim();
            if (isEmpty(code) || used.has(code)) return;
            used.add(code);
            normalized.push({
                code: code,
                name: "",
                SZP_POSSIZECD: String(DicVal(row, "SZP_POSSIZECD", DicVal(row, "SZPC_POSSIZECD", ""))).trim(),
                SZP_SIZECD: code
            });
        });
        return normalized;
    }
    function samePdtcSizeOptions(left, right) {
        const a = Array.isArray(left) ? left : [];
        const b = Array.isArray(right) ? right : [];
        if (a.length !== b.length) return false;
        return a.every((item, index) => {
            const next = b[index] || {};
            return String(DicVal(item, "code", "")) === String(DicVal(next, "code", ""))
                && String(DicVal(item, "name", "")) === String(DicVal(next, "name", ""));
        });
    }
    function applyPdtcSizeOptions(sizeInfoList) {
        const options = normalizePdtcSizeOptions(sizeInfoList);
        if (!samePdtcSizeOptions(pdtcSizeOptionsRef.current, options)) {
            pdtcSizeOptionsRef.current = options;
        }
        const updateFields = (prev) => {
            if (isEmpty(prev)) return prev;
            let changed = false;
            const next = prev.map((field) => {
                const fieldId = DicVal(field, "columnid", DicVal(field, "colId", DicVal(field, "field", "")));
                if (!matchesColumnId(fieldId, "PDTC_SIZECD")) return field;
                const currentOptions = Array.isArray(DicVal(field, "options", null)) ? field.options : [];
                if (field.datatype === CELLTYPE.SELECT && isEmpty(DicVal(field, "dataid", "")) && samePdtcSizeOptions(currentOptions, options)) return field;
                changed = true;
                return {
                    ...field,
                    datatype: CELLTYPE.SELECT,
                    dataid: "",
                    options: options.map((item) => ({ ...item }))
                };
            });
            return changed ? next : prev;
        };
        setcolumninfo(updateFields);
        setcolumns(updateFields);
        settextfields(updateFields);
        settextfieldsall(updateFields);
    }
    function isPdtSizePatternFieldId(columnid) {
        return PDT_SIZE_PATTERN_FIELD_IDS.some((fieldId) => matchesColumnId(columnid, fieldId));
    }
    function hasPdtSizeDetailListData() {
        const sizePanel = pdtcDetailPanel("210");
        if (isEmpty(sizePanel)) return false;
        const readRows = () => {
            const rows = GridData(sizePanel);
            if (Array.isArray(rows)) return rows;
            const api = GridApi(sizePanel);
            if (!isEmpty(api) && !isEmpty(AGRef.current) && typeof AGRef.current.GetDatasource === "function") {
                return AGRef.current.GetDatasource(api);
            }
            return [];
        };
        const rows = readRows();
        return (Array.isArray(rows) ? rows : []).some((row) => isPdtcSizeRowSelected(row));
    }
    function canEditPdtSizePattern() {
        return pdtTenkaiCodeChangedAfterLoadRef.current || (formstatus === "NEW FORM" && !hasPdtSizeDetailListData());
    }
    function refreshPdtSizePatternEditableState() {
        applyPdtSizePatternOptions(pdtSizePatternOptionsRef.current);
    }
    function normalizePdtSizePatternOptions(sizePatternList) {
        const normalized = [];
        const used = new Set();
        (Array.isArray(sizePatternList) ? sizePatternList : []).forEach((row) => {
            const code = String(DicVal(row, "SZPC_SZPCODE", DicVal(row, "code", ""))).trim();
            if (isEmpty(code) || used.has(code)) return;
            used.add(code);
            const name = String(DicVal(row, "SZP_SIZEPTNNM", DicVal(row, "name", code))).trim();
            normalized.push({ code: code, name: isEmpty(name) ? code : name });
        });
        return normalized;
    }
    function sameCodeNameOptions(left, right) {
        const a = Array.isArray(left) ? left : [];
        const b = Array.isArray(right) ? right : [];
        if (a.length !== b.length) return false;
        return a.every((item, index) => {
            const next = b[index] || {};
            return String(DicVal(item, "code", "")) === String(DicVal(next, "code", ""))
                && String(DicVal(item, "name", "")) === String(DicVal(next, "name", ""));
        });
    }
    function applyPdtSizePatternOptions(sizePatternList, currentData) {
        const options = normalizePdtSizePatternOptions(sizePatternList);
        const currentCode = currentPdtSizePatternCode(isEmpty(currentData) ? entrydataRef.current : currentData);
        if (!isEmpty(currentCode) && !options.some((item) => String(DicVal(item, "code", "")).trim() === currentCode)) {
            options.push({ code: currentCode, name: currentCode });
        }
        if (!sameCodeNameOptions(pdtSizePatternOptionsRef.current, options)) {
            pdtSizePatternOptionsRef.current = options;
        }
        const updateFields = (prev) => {
            if (isEmpty(prev)) return prev;
            let changed = false;
            const next = prev.map((field) => {
                const fieldId = DicVal(field, "columnid", DicVal(field, "colId", DicVal(field, "field", "")));
                if (!isPdtSizePatternFieldId(fieldId)) return field;
                const currentOptions = Array.isArray(DicVal(field, "options", null)) ? field.options : [];
                const nextLocked = !canEditPdtSizePattern();
                if (field.datatype === CELLTYPE.SELECT
                    && isEmpty(DicVal(field, "dataid", ""))
                    && sameCodeNameOptions(currentOptions, options)
                    && !!DicVal(field, "hideDisplayName", false)
                    && field.locked === nextLocked) return field;
                changed = true;
                return {
                    ...field,
                    datatype: CELLTYPE.SELECT,
                    dataid: "",
                    options: options.map((item) => ({ ...item })),
                    hideDisplayName: true,
                    locked: nextLocked
                };
            });
            return changed ? next : prev;
        };
        setcolumninfo(updateFields);
        setcolumns(updateFields);
        settextfields(updateFields);
        settextfieldsall(updateFields);
    }
    function loadPdtSizePatternOptions(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(targetData) ? {} : targetData)
        };
        const brandCode = String(resolveBrandGroupBrandCode(source)).trim();
        const itemCode = String(firstNonEmptyValue(source, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        if (isEmpty(brandCode) || isEmpty(itemCode)) {
            applyPdtSizePatternOptions([]);
            return;
        }

        const requestSeq = ++pdtSizePatternOptionsRequestSeqRef.current;
        if (isEmpty(fnc.current)) return;
        fnc.current.postaxios("hinbanmaster/GetPdtSizePatternOptions",
            {
                PDT_BRDCODE: brandCode,
                PDT_ITMCITEMCD: itemCode
            },
            {
                onSuccess: function (data) {
                    if (requestSeq !== pdtSizePatternOptionsRequestSeqRef.current) return;
                    let sizePatternList = [];
                    try {
                        sizePatternList = JSON.parse(DicVal(data.returnData, "SZPC_LIST", "[]")) || [];
                    } catch (e) {
                        sizePatternList = [];
                    }
                    applyPdtSizePatternOptions(sizePatternList, source);
                    const autoSelectFirst = DicVal(requestOptions, "autoSelectFirst", false) && formstatus === "NEW FORM";
                    const firstSizePatternCode = String(DicVal(DicVal(normalizePdtSizePatternOptions(sizePatternList), 0, {}), "code", "")).trim();
                    if (autoSelectFirst && !isEmpty(firstSizePatternCode)) {
                        let changed = false;
                        if (setPdtSizePatternOnData(source, firstSizePatternCode)) {
                            changed = true;
                        }
                        if (!isEmpty(targetData) && targetData !== entrydataRef.current && setPdtSizePatternOnData(targetData, firstSizePatternCode)) {
                            changed = true;
                        }
                        if (changed) {
                            assignEntryDataCurrent(protectHbSeasonCommit(source, "source"), "source");
                            updateSectionHeaderSizePatternValue(firstSizePatternCode);
                            dispatch(entrydata({ ...entrydataRef.current }));
                            dispatch(entryrerender());
                        }
                        loadPdtSizePatternSizeOptions(firstSizePatternCode, {
                            silent: true,
                            targetData: targetData
                        });
                    }
                },
                onError: function () {
                    if (requestSeq !== pdtSizePatternOptionsRequestSeqRef.current) return;
                    applyPdtSizePatternOptions([]);
                }
            }, true
        );
    }
    function buildPdtSizePatternSearchField(field, currentData) {
        if (isEmpty(field) || !isPdtSizePatternFieldId(DicVal(field, "columnid", ""))) return null;
        return {
            ...field,
            datatype: CELLTYPE.SELECT,
            dataid: "",
            hideDisplayName: true,
            options: pdtSizePatternOptionsRef.current.map((item) => ({ ...item }))
        };
    }
    function currentPdtSizePatternCode(source) {
        return String(firstNonEmptyValue(source, PDT_SIZE_PATTERN_FIELD_IDS)).trim();
    }
    function loadPdtSizePatternSizeOptions(sizePatternCode, options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(targetData) ? {} : targetData)
        };
        const requestSizePatternCode = String(isEmpty(sizePatternCode) ? currentPdtSizePatternCode(source) : sizePatternCode).trim();
        if (isEmpty(requestSizePatternCode)) {
            applyPdtcSizeOptions([]);
            if (!DicVal(requestOptions, "silent", true)) fnc.current.warnmsg(PDTC_SIZE_PATTERN_REQUIRED_MESSAGE);
            return;
        }
        const brandCode = String(resolveBrandGroupBrandCode(source)).trim();
        const itemCode = String(firstNonEmptyValue(source, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        if (isEmpty(brandCode) || isEmpty(itemCode)) {
            applyPdtcSizeOptions([]);
            return;
        }

        const requestSeq = ++pdtcSizePatternRequestSeqRef.current;
        if (isEmpty(fnc.current)) return;
        fnc.current.postaxios("hinbanmaster/GetPdtSizePatternSizeOptions",
            {
                PDT_BRDCODE: brandCode,
                PDT_ITMCITEMCD: itemCode,
                PDT_SIZEPATTERNCODE: requestSizePatternCode
            },
            {
                onSuccess: function (data) {
                    if (requestSeq !== pdtcSizePatternRequestSeqRef.current) return;
                    let sizeInfoList = [];
                    try {
                        sizeInfoList = JSON.parse(DicVal(data.returnData, "SZP_LIST", "[]")) || [];
                    } catch (e) {
                        sizeInfoList = [];
                    }
                    applyPdtcSizeOptions(sizeInfoList);
                },
                onError: function (data) {
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = String(DicVal(data, "errDescription", "")).trim();
                        fnc.current.warnmsg(isEmpty(msg) ? PDTC_SIZE_PATTERN_REQUIRED_MESSAGE : msg);
                    }
                }
            }, true
        );
    }
    function buildPdtcSizeSearchField(field, currentData) {
        if (isEmpty(field) || !matchesColumnId(DicVal(field, "columnid", ""), "PDTC_SIZECD")) return null;
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(currentData) ? {} : currentData)
        };
        if (isEmpty(currentPdtSizePatternCode(source))) {
            fnc.current.warnmsg(PDTC_SIZE_PATTERN_REQUIRED_MESSAGE);
            return false;
        }
        return {
            ...field,
            datatype: CELLTYPE.SELECT,
            dataid: "",
            options: pdtcSizeOptionsRef.current.map((item) => ({ ...item }))
        };
    }
    function setPdtSizePatternOnData(targetData, sizePatternCode) {
        if (isEmpty(targetData)) return false;
        const nextValue = String(isEmpty(sizePatternCode) ? "" : sizePatternCode);
        const targetKeys = PDT_SIZE_PATTERN_FIELD_IDS.filter((key) => key in targetData);
        if (targetKeys.length === 0) targetKeys.push("PDT_SIZEPATUN");
        let changed = false;
        targetKeys.forEach((key) => {
            if (String(DicVal(targetData, key, "")) === nextValue) return;
            targetData[key] = nextValue;
            changed = true;
        });
        return changed;
    }
    // サイズパターンマスタから行を作れないとき(M_SZPC未整備・取得失敗など)のフォールバック。
    // 展開コードありの読込では 210 グリッドは空行のまま遅延され、このロードが埋める前提のため、
    // 埋められない場合は M_PDTC 由来のSKU行(initialPdtcDetail220Ref)からサイズ行を導出して表示する。
    // 空のまま放置すると表示欠落に加え、保存時にサイズ空として扱われる。
    function fillPdtcSizeRowsFromSkuFallback() {
        const skuSizeCodes = pdtcSizeCodesFromSkuRows(initialPdtcDetail220Ref.current);
        const fallbackSizeCodes = Array.from(isEmpty(skuSizeCodes) ? [] : skuSizeCodes);
        if (fallbackSizeCodes.length === 0) return;
        setPdtcSizeCodesToDetailGrid(fallbackSizeCodes, [], { overwrite: true });
    }
    function loadPdtTenkaiSizePatternInfo(tenkaiCode, options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        const source = {
            ...(isEmpty(entrydataRef.current) ? {} : entrydataRef.current),
            ...(isEmpty(targetData) ? {} : targetData)
        };
        const requestTenkaiCode = String(isEmpty(tenkaiCode) ? DicVal(source, "PDT_TENKAICODE", "") : tenkaiCode).trim();
        const brandCode = String(resolveBrandGroupBrandCode(source)).trim();
        const itemCode = String(firstNonEmptyValue(source, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        if (isEmpty(requestTenkaiCode) || isEmpty(brandCode) || isEmpty(itemCode)) {
            fillPdtcSizeRowsFromSkuFallback();
            return;
        }

        if (isEmpty(fnc.current)) return;
        fnc.current.postaxios("hinbanmaster/GetPdtTenkaiSizePatternInfo",
            {
                PDT_BRDCODE: brandCode,
                PDT_ITMCITEMCD: itemCode,
                PDT_TENKAICODE: requestTenkaiCode
            },
            {
                onSuccess: function (data) {
                    if (String(DicVal(data.returnData, "Found", "false")).toLowerCase() !== "true") {
                        fillPdtcSizeRowsFromSkuFallback();
                        return;
                    }
                    const sizePatternCode = String(DicVal(data.returnData, "SZPI_SZPCODE", "")).trim();
                    let sizeInfoList = [];
                    try {
                        sizeInfoList = JSON.parse(DicVal(data.returnData, "SZP_LIST", "[]")) || [];
                    } catch (e) {
                        sizeInfoList = [];
                    }
                    const sizeCodes = sizeInfoList
                        .map((row) => String(DicVal(row, "SZP_SIZECD", "")).trim())
                        .filter((sizeCode) => !isEmpty(sizeCode));
                    const posSizeCodes = sizeInfoList
                        .map((row) => String(DicVal(row, "SZP_POSSIZECD", "")).trim());
                    applyPdtcSizeOptions(sizeInfoList);

                    let changed = false;
                    if (setPdtSizePatternOnData(source, sizePatternCode)) {
                        changed = true;
                    }
                    if (!isEmpty(targetData) && targetData !== entrydataRef.current && setPdtSizePatternOnData(targetData, sizePatternCode)) {
                        changed = true;
                    }
                    if (changed) {
                        assignEntryDataCurrent({ ...source }, "source");
                        dispatch(entrydata({ ...entrydataRef.current }));
                        dispatch(entryrerender());
                    }
                    updateSectionHeaderSizePatternValue(sizePatternCode);
                    dispatch(entryrerender());
                    if (sizeCodes.length === 0) {
                        // パターンは特定できたが構成(M_SZPC)が空のケース。空で上書きすると
                        // サイズ行が消えるため、SKU由来のサイズでフォールバック表示する。
                        fillPdtcSizeRowsFromSkuFallback();
                    } else {
                        setPdtcSizeCodesToDetailGrid(sizeCodes, posSizeCodes, {
                            overwrite: true
                        });
                    }
                    refreshPdtSizePatternEditableState();
                },
                onError: function (data) {
                    fillPdtcSizeRowsFromSkuFallback();
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "サイズ展開コードのサイズ情報取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }

    return {
        resolveItemMasterItemCode,
        applyFirstExistingValue,
        setPdtItmcItemCdOnEntryData,
        clearPdtTenkaiCodeValue,
        applyPdtTenkaiCodeAutoSelection,
        pdtTenkaiCodeOptionsFromReturnData,
        loadPdtTenkaiCodeOptionsForData,
        refreshPdtItmcItemCdDependentOptions,
        buildPdtTenkaiSearchField,
        normalizeSubBrandOptions,
        currentSubBrandOptions,
        applySubBrandNameToEntryData,
        loadSubBrandName,
        buildSubBrandSearchField,
        buildBrandHinbanSearchField,
        isKakousijiSubSoseiSearchField,
        ensureSubSoseiSearchParentCode,
        buildBaseSearchField,
        syncItemDependentData,
        pdtItemCodesPanel,
        pdtcSizeCodePanels,
        setDetailColumnValues,
        setPdtItemCodesToDetailGrid,
        normalizeDetailColumnValues,
        displayInitialBlankDetailGridRow,
        overwriteDetailColumnValues,
        setPdtcSizeCodesToDetailGrid,
        normalizePdtcSizeOptions,
        samePdtcSizeOptions,
        applyPdtcSizeOptions,
        isPdtSizePatternFieldId,
        hasPdtSizeDetailListData,
        canEditPdtSizePattern,
        refreshPdtSizePatternEditableState,
        normalizePdtSizePatternOptions,
        sameCodeNameOptions,
        applyPdtSizePatternOptions,
        loadPdtSizePatternOptions,
        buildPdtSizePatternSearchField,
        currentPdtSizePatternCode,
        loadPdtSizePatternSizeOptions,
        buildPdtcSizeSearchField,
        setPdtSizePatternOnData,
        loadPdtTenkaiSizePatternInfo
    };
}
